import request, { ResponseData } from '@/utils/request'

// 获取快捷短语列表
export async function phraseList(params) {
  return request('/api/v1/sys/phrase/list', {
    method: 'post',
    data: params,
  })
}

// 删除快捷短语
export async function deletePhrase(params) {
  return request('/api/v1/sys/phrase/del', {
    method: 'post',
    data: params,
  })
}

// 导入快捷短语2.0
export async function ImportPhraseDownloadCenter(params) {
  return request('/api/v1/sys/phrase/upload_url', {
    method: 'post',
    data: params,
  })
}

// 获取分组
export async function fetchGroupList(params) {
  return request('/api/v1/sys/phrase/group', {
    method: 'post',
    data: params,
  })
}

// 快捷短语编辑和新建
export async function operatePhrase(params) {
  return request('/api/v1/sys/phrase/modify', {
    method: 'post',
    data: params,
  })
}

export async function deleteGroup(params) {
  return request('/api/v1/sys/phrase/group/del', {
    method: 'post',
    data: params,
  })
}

export async function clearPhrase() {
  return request('/api/v1/sys/phrase/clear_all', {
    method: 'post',
  })
}

// 快捷短语分组创建
export async function addAndEditGroup(params) {
  return request('/api/v1/sys/phrase/group/save', {
    method: 'post',
    data: params,
  })
}

// 快捷短语批量分组
export async function BatchGrouping(params) {
  return request('/api/v1/sys/phrase/move', {
    method: 'post',
    data: params,
  })
}

// 快捷短语批量分组
export async function shortListByPage(params) {
  return request('/api/v1/sys/phrase/page', {
    method: 'post',
    data: params,
  })
}
